
import {Component, Vue} from "vue-property-decorator";
import {getFinancialConfiguration, updateFinancialConfiguration} from "@/api/configuration";

class FinancialConfiguration {
  exchangeRateUSD: string;
  merUSD: string;
  exchangeRateEURO: string;
  merEURO: string;
  exchangeRateRMB: string;
  merRMB: string;

  constructor(exchangeRateUSD: string, merUSD: string, exchangeRateEURO: string, merEURO: string, exchangeRateRMB: string, merRMB: string) {
    this.exchangeRateUSD = exchangeRateUSD;
    this.merUSD = merUSD;
    this.exchangeRateEURO = exchangeRateEURO;
    this.merEURO = merEURO;
    this.exchangeRateRMB = exchangeRateRMB;
    this.merRMB = merRMB;
  }
}

@Component({
  name: "ExchangeRateForm",
  components: {},
})
export default class extends Vue {

  private showEditExchangeRate = false; // 调整汇率-弹窗隐显

  numberValidator(rule, value, callback) {
    if (!/^\d+(\.\d+)?$/.test(value)) {
      return callback(new Error("请输入有效的数字"));
    }
    // 如果通过验证，则回调无参数
    callback();
  }


  private rules = {
    exchangeRateUSD: [
      {required: true, message: "请输入美元汇率", trigger: "blur"},
      {validator: this.numberValidator, trigger: "blur"},
    ],
    merUSD: [
      {required: true, message: "请输入美元MER值", trigger: "blur"},
      {validator: this.numberValidator, trigger: "blur"},
    ],
    exchangeRateEURO: [
      {required: true, message: "请输入欧元汇率", trigger: "blur"},
      {validator: this.numberValidator, trigger: "blur"},
    ],
    merEURO: [
      {required: true, message: "请输入欧元MER值", trigger: "blur"},
      {validator: this.numberValidator, trigger: "blur"},
    ],
    exchangeRateRMB: [
      {required: true, message: "请输入人民币汇率", trigger: "blur"},
    ],
    merRMB: [
      {required: true, message: "请输入人民币MER值", trigger: "blur"},
      {validator: this.numberValidator, trigger: "blur"},
    ]
  };

  private financialConfiguration: FinancialConfiguration =
      new FinancialConfiguration(null, null, null, null, null, null);

  public async show() {
    const {
      exchangeRateUSD,
      merUSD,
      exchangeRateEURO,
      merEURO,
      exchangeRateRMB,
      merRMB
    }: any = await getFinancialConfiguration();
    this.financialConfiguration = new FinancialConfiguration(exchangeRateUSD, merUSD, exchangeRateEURO, merEURO, exchangeRateRMB, merRMB);
    this.showEditExchangeRate = true;
  }

  private async confirmFinancialConfiguration() {
    await updateFinancialConfiguration(
        this.financialConfiguration.exchangeRateUSD,
        this.financialConfiguration.merUSD,
        this.financialConfiguration.exchangeRateEURO,
        this.financialConfiguration.merEURO,
        this.financialConfiguration.exchangeRateRMB,
        this.financialConfiguration.merRMB
    ).then(async res => {
      this.$notify({
        title: "Success",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.showEditExchangeRate = false
    }).catch(err => {
      console.log(err);
    });
  }
}
